<div class="tree-root">
  <ng-container *ngIf="treeModel && treeModel.roots">
    <ng-container *ngFor="let node of treeModel.roots; let i = index; trackBy: trackByNodeId">
      <ng-container *ngIf="!node.isHidden">
        <ng-container
          *ngTemplateOutlet="treeNodeFullTemplate; context: { $implicit: node, index: i, templates: { treeNodeFullTemplate: treeNodeFullTemplate } }">
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

